import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { createHashRouter, Navigate, RouterProvider } from "react-router-dom";
import {
  HashRouter as Router,
  Routes,
  Route,
  useParams,
  useNavigate,
} from "react-router-dom";
import { Navigate, Outlet } from "react-router-dom";

import "./App.css";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import Feedback from "./pages/feedback/Feedback";
import Offer from "./pages/offer/Offer";
import Otp from "./pages/otp/Otplogin";
import NeedHelp from "./pages/help/Needhelp";
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy";
import Faqs from "./pages/faqs/Faqs";
import ContactUs from "./pages/contact-us/ContactUs";
import AvenueMalls from "./pages/malls/AvenueMalls";
import PointHistory from "./pages/pointHistory/PointHistory";
import FamilyFriend from "./pages/familyFriends/FamilyFriend";
import DlfMall from "./pages/dlfMallsPage/DlfMalls";
import EditProfile from "./pages/editProfile/editProfile";
import NewCustomer from "./pages/new-customer/NewCustomer";
import OfferPage from "./pages/offer-page/OfferPage";
import OffersHistory from "./pages/offers-history/OffersHistory";
import Privacy from "./pages/Privacy/Privacy";
import Terms from "./pages/terms/terms";
import TermsPublic from "./pages/termsPublic/TermsPublic";
import StorePage from "./pages/Store-page/StorePage";
import DeleteAccount from "./pages/deleteAccount/DeleteAccount";
import { fetchLocalizes } from "./redux/slice/localizes";
import TierHistory from "./pages/tier-history/TierHistory";

function App() {
  const dispatch = useDispatch();
  const {
    data: localizesData,
    loading: localizesLoading,
    error: localizesError,
  } = useSelector((state) => state.localizes);

  // Fetch localizes data when app starts
  useEffect(() => {
    dispatch(fetchLocalizes());
  }, [dispatch]);

  // const router = createHashRouter([
  //   {
  //     path: "/",
  //     element: <Navigate to="/login" replace />, // Redirect root path to /home
  //   },
  //   {
  //     path: "/login",
  //     element: <Login />,
  //   },
  //   {
  //     path: "/new-customer",
  //     element: <NewCustomer />,
  //   },
  //   {
  //     path: "/otp",
  //     element: <Otp />,
  //   },
  //   {
  //     path: "/home",
  //     element: <Home />,
  //   },
  //   {
  //     path: "/feedback",
  //     element: <Feedback />,
  //   },
  //   {
  //     path: "/offers",
  //     element: <Offer />,
  //   },
  //   {
  //     path: "/reward-page",
  //     element: <OfferPage />,
  //   },
  //   {
  //     path: "/rewards-catalogue",
  //     element: <OffersHistory />,
  //   },
  //   {
  //     path: "/need-help",
  //     element: <NeedHelp />,
  //   },
  //   {
  //     path: "/privacy-policy",
  //     element: <PrivacyPolicy />,
  //   },
  //   {
  //     path: "/faqs",
  //     element: <Faqs />,
  //   },
  //   {
  //     path: "/contact-us",
  //     element: <ContactUs />,
  //   },
  //   {
  //     path: "/avenue-mall",
  //     element: <AvenueMalls />,
  //   },
  //   {
  //     path: "/point-history",
  //     element: <PointHistory />,
  //   },
  //   {
  //     path: "/friends-family",
  //     element: <FamilyFriend />,
  //   },
  //   {
  //     path: "/dlf-malls",
  //     element: <DlfMall />,
  //   },
  //   {
  //     path: "/avenueMalls",
  //     element: <AvenueMalls />,
  //   },
  //   {
  //     path: "/edit-profile",
  //     element: <EditProfile />,
  //   },
  // ]);

  const PrivateRoutes = () => {
    let sessionId = localStorage.getItem("sessionId");
    let token = localStorage.getItem("token");
    return sessionId ? <Outlet /> : <Navigate to="/Login" />;
  };

  const CaptureIdAndRedirect = () => {
    const { id } = useParams(); // This captures URL params, but for hash you need a different approach.
    const navigate = useNavigate();

    useEffect(() => {
      if (id) {
        sessionStorage.setItem("redirectId", id); // Store the ID
      }

      // Redirect to login after capturing the ID
      navigate("/login");
    }, []); // Empty dependency array to run the effect once on component mount

    return null; // Since you want to redirect to login, nothing needs to be rendered
  };

  // const { customerDetailsData } = useSelector((state) => state.customerDetails);

  // useEffect(() => {
  //   dispatch(fetchCustomerDetails());
  // }, []);
  // console.log(customerDetailsData, "customerDetailsData in app");
  return (
    <>
      {/* <RouterProvider router={router} /> */}

      <Router>
        <Routes>
          <Route path="/:id" element={<CaptureIdAndRedirect />} />
          <Route element={<PrivateRoutes />}>
            {/* <Route path="/" element={<Users />} /> */}
            <Route path="/new-customer" element={<NewCustomer />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/home" element={<Home />} />
            <Route path="/:id" element={<CaptureIdAndRedirect />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/offers" element={<Offer />} />
            <Route path="/store-page" element={<StorePage />} />
            <Route path="/reward-page" element={<OfferPage />} />
            <Route path="/rewards-catalogue" element={<OffersHistory />} />
            <Route path="/need-help" element={<NeedHelp />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/tier-history" element={<TierHistory />} />

            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/avenue-mall" element={<AvenueMalls />} />
            <Route path="/point-history" element={<PointHistory />} />
            {/* <Route path="/friends-family" element={<FamilyFriend />} /> */}
            <Route path="/dlf-malls" element={<DlfMall />} />

            <Route path="/avenueMalls" element={<AvenueMalls />} />
            <Route path="/edit-profile" element={<EditProfile />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<TermsPublic />} />
        </Routes>
      </Router>
      {/* <Login /> */}
    </>
  );
}

export default App;
